import store from "../../store";
import api from "../request";
import qs from "qs";
import { Promise } from "q";



function getTestResultsList(reqData) {
    return api
        .post("result-analysis/test-result-list", { reqData })
        .then(({ data }) => {
            return data;
        })
}

function getChapterWiseInfo(reqData) {
    return api
        .post("test/-", { reqData })
        .then(({ data }) => {
            return data;
        })
}

function getTopicWiseInfo(reqData) {
    return api
        .post("test/-", { reqData })
        .then(({ data }) => {
            return data;
        })
}

function getBatchWiseHealth(reqData) {
  return api
      .post("health/batch-wise", { reqData })
      .then(({ data }) => {
          return data;
      })
}
function getAllBatchWiseHealth(reqData) {
  return api
      .post("health/all-batch-wise", { reqData })
      .then(({ data }) => {
          return data;
      })
}
function getSubjectHealthStudentWise(reqData) {
  return api
      .post("health/student-wise", { reqData })
      .then(({ data }) => {
          return data;
      })
}
function getScoreData(reqData) {
    return api
        .post("result-analysis/compare-score", { reqData })
        .then(({ data }) => {
            return data;
        })
}
function getSubjectsList(reqData) {
    return api
        .post("subject-list", { reqData })
        .then(({ data }) => {
            return data;
        })
}
function getScoreBySubjectId(reqData) {
    return api
        .post("result-analysis/negative_marking_impact", { reqData })
        .then(({ data }) => {
            return data;
        })
}
function getTestWiseAnalysisList(reqData) {
    return api
      .post("result-analysis/test-wise-list", { reqData })
      .then(({ data }) => {
        return data;
      })
  }
  function getDataForChapterWisePerformance(reqData) {
    return api
      .post("result-analysis/chapter-standing", { reqData })
      .then(({ data }) => {
        return data;
      })
  }
  function getTimeMachineList(reqData) {
    return api
      .post("result-analysis/time-machine", { reqData })
      .then(({ data }) => {
        return data;
      })
  }
  function getDetailsOfAttempList(reqData) {
    return api
      .post("result-analysis/attempt-details", { reqData })
      .then(({ data }) => {
        return data;
      })
  }
  function getTestSubjects(reqData) {
    return api
      .post("test/subjects", { reqData })
      .then(({ data }) => {
        return data;
      })
  }
  function getSubjectBatchWise(reqData) {
    return api
      .post("data-tree/batch-subjects", { reqData })
      .then(({ data }) => {
        return data;
      })
  }
  function getPercentileData(reqData) {
    return api
      .post("result-analysis/percentile-variation", { reqData })
      .then(({ data }) => {
        return data;
      })
  }
  function objectQuestion(reqData) {
    return api
      .post("questions/object-questions", { reqData })
      .then(({ data }) => {
        return data;
      })
  }
  function getQuestionDetails(reqData) {
    return api
      .post("questions/get-question-details", { reqData })
      .then(({ data }) => {
        return data;
      })
  }
  function getStudentSubjectTree(reqData) {
    return api
      .post("users/get-student-subject-tree", { reqData })
      .then(({ data }) => {
        return data;
      })
  }
  function getChildren(reqData) {
    return api
      .post("data-tree/get-chidren", { reqData })
      .then(({ data }) => {
        return data;
      })
  }
  function checkResultCalculated(reqData) {
    return api
      .post("result-analysis/check-test-result-calculated", { reqData })
      .then(({ data }) => {
        return data;
      })
  }
  function publishResults(reqData) {
    return api
      .post("result-analysis/publish-results", { reqData })
      .then(({ data }) => {
        return data;
      })
  }
  export default {
    getTestResultsList,
    getChapterWiseInfo,
    getTopicWiseInfo,
    getBatchWiseHealth,
    getAllBatchWiseHealth,
    getScoreData,
    getSubjectsList,
    getScoreBySubjectId,
    getTestWiseAnalysisList,
    getDataForChapterWisePerformance,
    getTimeMachineList,
    getTestSubjects,
    getDetailsOfAttempList,
    getSubjectBatchWise,
    getPercentileData,
    objectQuestion,
    getSubjectHealthStudentWise,
    getQuestionDetails,
    getStudentSubjectTree,
    getChildren,
    checkResultCalculated,
    publishResults
};